import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import { BiCategoryAlt } from "react-icons/bi";
import { withTranslation } from "react-i18next";
import { toastConfirm } from "common/toast";
const SidebarContent = (props) => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }
  const history = useHistory();
  const handleLogout = () => {
    toastConfirm("Are you sure?", `You want to Log Out?`)
      .fire()
      .then(async ({ isConfirmed }) => {
        if (isConfirmed) {
          history.push("/logout");
        }
      });
  };
  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/admin/dashboard">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/" className="has-arrow">
                <i className="bx bx-customize"></i>
                <span>{props.t("User Manager")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/admin/all-users">
                    <span>{"All Users"}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/admin/airdrop">
                    <span>{"Airdrop"}</span>
                  </Link>
                </li>
              </ul>
            </li>

            <li className=" ">
              <Link to="/" className="has-arrow">
                <i className="bx bx-customize"></i>
                <span>{props.t("Swap")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/admin/commission">
                    <span>{props.t("Commission")}</span>
                  </Link>
                </li>
              </ul>
            </li>
            {/* <li className="menu-title">
              <i className="mdi mdi-arrow-right-drop-circle-outline font-size-12"></i>{" "}
              {props.t("Settings")}
            </li> */}
            <li>
              <Link to="/admin/faqs">
                <i className="bx bx-customize"></i>
                <span>{props.t("FAQ")}</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/plans">
                <i className="bx bx-customize"></i>
                <span>{props.t("Plans")}</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/stacking">
                <i className="bx bx-customize"></i>
                <span>{props.t("Stacking")}</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/category">
              <BiCategoryAlt className="fs-5"/>
                <span className="ms-2">{props.t("Category")}</span>
              </Link>
            </li>
            <li>
              <Link to="/admin/profile">
                <i className="bx bx-user"></i>
                <span>{props.t("Profile")}</span>
              </Link>
            </li>
            <li>
              <Link onClick={handleLogout} className="" to={"#"}>
                <i className="bx bx-power-off"></i>
                <span>{props.t("Logout")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
